<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">{{ customer_name }}</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link>
      /
      <router-link to="/customers">Customers</router-link>
      /
      <b>Details</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="row">
      <div class="col-md-12">
        <div class="card mb-4">
          <div class="card-body">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item">
                <a class="nav-link active show" id="profile-tab" data-toggle="tab" href="#profile" role="tab"
                  aria-controls="profile" aria-selected="true">Profile</a>
              </li>
            </ul>

            <div class="tab-content" id="myTabContent">
              <profile :profile="profile"></profile>
              <certificate></certificate>
              <claim></claim>
            </div>
            <div class="py-4">
              Login and Logout Logs
            </div>
            <Logs :tableId="'login-out'" :data="logoutData" :pageInfo="pageInfo" @paginate="handlePageChange" :isNeed="false" />
            <div class="py-4">
              Account Status Logs
            </div>
            <Logs :tableId="'status-logs'" :data="statusData" :pageInfo="pageInfo2" @paginate="handlePageChange2" :isNeed="false" />
          </div>
        </div>
      </div>
    </div>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="fullPage"></loading>
  </div>
</template>

<style>
.active {
  background: none;
}
</style>

<script>
// @ is an alias to /src
import axios from "axios";
import Profile from "@/views/contents/customers/Customer_profile.vue";
import Certificate from "@/views/contents/customers/Customer_certificate.vue";
import Claim from "@/views/contents/customers/Customer_claim.vue";
import moment from "moment";
import Logs from "./Logs.vue"
import { getRequest } from '@/services/RequestService';
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "customer_details",
  components: {
    Profile,
    Claim,
    Logs,
    Loading
  },

  data() {
    return {

      profile: {
        ic_number: "",
        ic_colour: "",
        full_name: "",
        marital_status: "",
        gender: "",
        nationality: "",
        mobile_number: "",
        address1: "",
        address2: "",
        address3: "",
        office_address: "",
        religion: "",
        date_of_birth: "",
        postal_code: "",
        occupation: "",
        kampong: "",
        email: "",
        created_at: "",
        declined_at: "",
        declined_reason: ""
      },

      logoutData: [],
      pageInfo: {},
      mainApi: ``,

      statusData: [],
      pageInfo2: {},
      secondApi: ``,

      isLoading: false,
    };
  },

  methods: {
    async loadProfile() {
      let token = localStorage.getItem("token");
      this.ic_number = this.$route.params.ic_number;

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        await axios
          .get(axios.baseURL2 + "/customer?ic_number=" + this.ic_number, {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            // this.customer_name = res.data.user.name
            this.profile = res.data;

            this.profile.created_at =
              this.profile.created_at == null
                ? null
                : moment(this.profile.created_at).format("Do MMMM YYYY");
            this.profile.email_verified_at =
              this.profile.email_verified_at == null
                ? null
                : moment(this.profile.email_verified_at).format("Do MMMM YYYY");
            this.profile.declined_at =
              this.profile.declined_at == null
                ? null
                : moment(this.profile.declined_at).format("Do MMMM YYYY");
          });
      }
    },

    async loadLogoutLog() {
      let user_id = localStorage.getItem('user_det');

      this.mainApi = `/users/logs?user_id=${user_id}`;

      try {
        let result = await getRequest(this.mainApi);

        this.logoutData = result.data.logs;
        this.pageInfo = result.data.pagination;


      } catch (e) {
        console.log(e);
      }
    },

    async loadStatusLog() {
      this.secondApi = `/users/accounts/logs?page=1`;
      try {
        let result = await getRequest(this.secondApi);

        this.statusData = result.data.logs;

        this.pageInfo2 = result.data.pagination;

      } catch (e) {
        console.log(e);
      }
    },

    async handlePageChange(page) {
      this.isLoading = true;

      let user_id = localStorage.getItem('user_det');

      this.mainApi = `/users/logs?user_id=${user_id}&page=${page}`;

      let result = await getRequest(this.mainApi)

      this.logoutData = result.data.data.logs;
      this.pageInfo = result.data.pagination;
      this.isLoading = false;
    },

    async handlePageChange2(page) {
      this.isLoading = true;

      let user_id = localStorage.getItem('user_det');

      this.secondApi = `/users/accounts/logs?user_id=${user_id}&page=${page}`;

      let result = await getRequest(this.secondApi)

      this.statusData = result.data.logs;
      this.pageInfo2 = result.data.pagination;
      this.isLoading = false;
    },

    loadTable(id) {
      $(id).DataTable({
        pageLength: 5,
        dom: "Bfrtip",
        buttons: [
          {
            extend: "excelHtml5",
          },
          {
            extend: "pdfHtml5",
          }
        ]
      });
    },

  },

  async created() {
    this.loading = true;
    await this.loadProfile();

    await this.loadLogoutLog();
    await this.loadStatusLog();

    setTimeout(() => {
      this.loadTable("#login-out");
      this.loadTable("#status-logs");
    }, 2000);
    

    this.loading = false;
  }
};
</script>
